import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { PromoPage } from './promo.page';
import { PipesModule } from "../../../theme/pipes/pipes.module";
import { CountDownComponent } from './count-down/count-down.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule
],
  declarations: [CountDownComponent, PromoPage]
})
export class PromoPageModule {}
